import { useContext } from 'react';

import { dashboardT } from './messages';
import { ShigoSessionContext } from './sessionContext';

export function useShigoSession() {
  const context = useContext(ShigoSessionContext);
  if (!context) {
    throw new Error(dashboardT('app.error.sessionProvider'));
  }

  return context;
}
